import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_halipak-solutions/artifacts/ujlq0d5n_image.png";

const Logo = ({ variant = "dark", showTagline = true }) => {
  const text = variant === "light" ? "#FFFFFF" : "#0A192F";
  const muted = variant === "light" ? "rgba(255,255,255,0.7)" : "#64748B";

  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div
        className={`shrink-0 ${
          variant === "light"
            ? "bg-white rounded-full p-1 shadow-sm"
            : ""
        }`}
      >
        <img
          src={LOGO_URL}
          alt="HALIPAK Kimya & Halı Hurcu logo"
          className="w-10 h-10 sm:w-11 sm:h-11 object-contain block"
          draggable="false"
        />
      </div>
      <div className="leading-none">
        <div
          className="font-heading font-extrabold text-xl sm:text-2xl tracking-tight"
          style={{ color: text }}
        >
          HALIPAK
        </div>
        {showTagline && (
          <div
            className="text-[10px] sm:text-[11px] font-medium uppercase tracking-[0.22em] mt-1"
            style={{ color: muted }}
          >
            Halı Hurcu &amp; Kimya
          </div>
        )}
      </div>
    </div>
  );
};

export default Logo;
